import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import {
  CreateCustomer,
  createCustomer,
  EditCustomer,
  editCustomer,
  fetchZoneList
} from '../../../../actions/index';
import { IAppState } from '../../../../reducers/index';
import Form from './Form';

interface IProps {
  customerid?: string;
}

const mapStateToProps = ({ customers, tables }: IAppState, props: IProps) => ({
  loading: tables.zones.listLoading || customers.form.loading,
  redirectReady: customers.form.redirectReady,
  redirectCustomerId: customers.form.redirectCustomerId,
  customer: customers.customers[Number(props.customerid || 0)],
  zones: tables.zones.list || [],
});

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    createCustomer: (properties: CreateCustomer) =>
      dispatch(createCustomer.request(properties)),
    editCustomer: (properties: EditCustomer) =>
      dispatch(editCustomer.request(properties)),
    fetchZoneList: () =>
      dispatch(fetchZoneList.request()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Form);
